import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { faAngleDown, faBarcode, faBars, faBell, faChevronRight, faCoffee, faCoins, faFolderOpen, faHandHoldingDollar, faHandshake, faHeartPulse, faHouse, faInbox, faPhone, faQuestion, faRightFromBracket, faSackDollar, faShieldHeart, faUser } from '@fortawesome/free-solid-svg-icons';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fadeIn, fadeOut } from 'src/app/animations';
import { SocialSecurityService } from 'src/app/pages/privado/services/previdencia/social-security.service';
import { BeneficiaryType } from '../../enum/beneficiary-type';
import { TipoBoleto } from '../../enum/tipo-boleto';
import { TipoProduto } from '../../enum/tipo-produto';
import { AuthService } from '../../guards/auth.service';
import { PersonService } from '../../services/person.service';
import { SidebarService } from '../../services/sidebar.service';
import { TokenService } from '../../services/token.service';
import { UsuarioService } from '../../services/usuario.service';
@Component({
  selector: 'side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
  animations: [fadeIn, fadeOut]
})
export class SideBarComponent implements OnInit {
  get beneficiaryType() { return BeneficiaryType; }
  get product() { return TipoProduto; }
  get boleto() { return TipoBoleto; }
  permissaoBoleto: boolean = true;
  imagem: any;
  pessoa: any;
  faCoffee = faCoffee;
  faInbox = faInbox;
  faBars = faBars;
  faChevronRight = faChevronRight;
  faHouse = faHouse;
  faHeartPulse = faHeartPulse;
  faSackDollar = faSackDollar;
  faHandHoldingDollar = faHandHoldingDollar;
  faUser = faUser;
  faBell = faBell;
  faPhone = faPhone;
  faRightFromBracket = faRightFromBracket;
  faShieldHeart = faShieldHeart;
  faAngleDown = faAngleDown;
  faCoins = faCoins;
  faFolderOpen = faFolderOpen;
  faBarcode = faBarcode;
  faQuestion = faQuestion;
  faHandshake = faHandshake;
  selected = new FormControl();
  lastDropdown: string = '';
  activeDropdown: string | null = null;
  actualUser: any = null;
  nome!: string;
  notificacoes: any;
  reestore: boolean = false;
  pdvAcess: any = false;
  pdvAcessCookie: any = null;
  pdvAcessLoading: any = false;
  isLoanProfile: boolean = false;
  isLoanProfileSimular: boolean = false;
  constructor(private personService: PersonService, private socialSecurityService: SocialSecurityService, private authService: AuthService, private deviceService: DeviceDetectorService,
    private userService: UsuarioService, private router: Router, private sidebarService: SidebarService, private tokenService: TokenService) {
    this.actualUser = this.tokenService.getActiveUser();
    // if( (this.actualUser?.hasPdvPermission == true || this.actualUser?.hasPdvPermission == 'true') && this.actualUser.socialSecurityProfile?.statusId != this.beneficiaryType.ASSISTIDO){
    //   this.pdvAcess = true;
    // }else{
    //   this.pdvAcess = false;
    // }
    if (this.actualUser && this.actualUser.socialSecurityProfile) {
      this.selected.setValue(this.actualUser.socialSecurityProfile?.id);
      if (this.actualUser.socialSecurityProfile?.statusId == 1 || this.actualUser.socialSecurityProfile?.statusId == 4 || this.actualUser.socialSecurityProfile?.statusId == 22) {
        this.isLoanProfile = true;
        if (this.actualUser.socialSecurityProfile?.statusId == 22) {
          this.isLoanProfileSimular = true;
        }
      }
    }
    this.personService.getPerson().subscribe(
      (res: any) => {
        this.pessoa = res;
      });
    this.personService.GetListUserNotifications().subscribe(
      (res: any) => {
        this.notificacoes = res;
      });
    this.userService.getUserProfilePicture().subscribe((data: any) => {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imagem = reader.result;
      }, false);
      if (data) {
        reader.readAsDataURL(data);
      }
    });
    this.socialSecurityService.CobrancaJudicialBoleto().subscribe((res: any) => {
      if (res == true)
        this.permissaoBoleto = false;
    })
  }
  pdvAcesso(): boolean {
    if (this.pdvAcess == null && this.pdvAcessLoading == false) {
      this.userService.getProfiles().subscribe({
        next: (res: any) => {
          this.pdvAcess = res.hasPdvPermission;
          return true;
        },
        error: (err: any) => {
        }
      })
    } else {
      return this.pdvAcess;
    }
    this.pdvAcessLoading = true;
    return false;
  }
  peculio(): boolean {
    let actualUser = this.tokenService.getActiveUser();
    if (actualUser && actualUser?.peculio === 1) {
      return true;
    }
    return false;
  }
  pdv(): boolean {
    let actualUser = this.tokenService.getActiveUser();
    if (actualUser && actualUser?.hasPdvPermission != null && this.actualUser.socialSecurityProfile?.statusId != this.beneficiaryType.ASSISTIDO) {
      return true;
    }
    return false;
  }
  getUserDataWithPromise(): Promise<any> {
    return new Promise((resolve: any, reject: any) => {
      try {
        let valor = this.tokenService.getActiveUser();
        resolve(valor);
      } catch (err: any) {
        reject(err);
      }
    })
  }
  toggleDropdown(dropDownSelect: string): void {
    let dropdown = this.lastDropdown;
    var dropdownItems = document.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(function (item) {
      if (item.classList.contains('show') && dropdown != dropDownSelect) {
        item.classList.remove('show');
      }
    });
    if (this.activeDropdown === null) {
      this.activeDropdown = dropDownSelect;
    } else if (this.activeDropdown != null && this.activeDropdown != dropDownSelect) {
      if (this.verificaItemAtivo(document.getElementById(this.activeDropdown)?.getElementsByClassName("item")) == false) {
        document.getElementById(this.activeDropdown)?.classList.remove('show');
      }
      this.activeDropdown = dropDownSelect;
    }
    this.lastDropdown = dropDownSelect;
  }
  //Usado quando recarregar a página
  validaPaginaRecarregada() {
    setTimeout(() => {
      if (this.verificaItemAtivo(document.getElementById('emprestimo')?.getElementsByClassName("item"))) {
        document.getElementById('emprestimo')?.classList.add('show');
        document.getElementById('dropwdown__emprestimo')?.setAttribute('aria-expanded', 'true');
      } else if (this.verificaItemAtivo(document.getElementById('previdencia')?.getElementsByClassName("item"))) {
        document.getElementById('previdencia')?.classList.add('show');
        document.getElementById('dropwdown__previdencia')?.setAttribute('aria-expanded', 'true');
      } else if (this.verificaItemAtivo(document.getElementById('saude')?.getElementsByClassName("item"))) {
        document.getElementById('saude')?.classList.add('show');
        document.getElementById('dropwdown__saude')?.setAttribute('aria-expanded', 'true');
      }
    }, 10);
  }
  closeAllDropdowns() {
    // Seleciona todos os elementos com a classe "dropdown-item"
    var dropdownItems = document.querySelectorAll('.dropdown-item');
    // Itera sobre os elementos e remove a classe "show"
    dropdownItems.forEach(function (item) {
      item.classList.remove('show');
    });
  }
  desativarFundo() {
    if (this.deviceService.isMobile()) {
      document.getElementById('nav-menu-toggle')?.click();
    }
  }
  logout() {
    this.authService.logout();
  }
  verificaItemAtivo(itens: any): Boolean {
    if (itens != null) {
      for (let i = 0; i < itens.length; i++) {
        if (itens[i].classList.contains("active")) {
          return true;
        }
      }
    }
    return false;
  }
  ngOnInit(): void {
    this.validaPaginaRecarregada();
  }
  @HostListener('click', ['$event.target']) onClick(e: any) {
    const sidebar = document.getElementById('sidebar');
    if (sidebar?.classList.contains('active') && e.classList.contains('link-menu')) {
      document.getElementById('menu-toggle')?.click();
    }
  }
}
